module.exports = "<div class=\"empty-div\">\n  <div class=\"card\">\n    <p>No Data Found</p>\n    <i class=\"fa fa-warning fa-custom-warning\"></i>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3830577117/src/src/app/generic-ui-components/no-records/no-records.component.html
// module id = ../../../../../src/app/generic-ui-components/no-records/no-records.component.html
// module chunks = main